<template>
  <div>
      <div class="content">
          <div v-for="(item,index) of childrenList" :key="index" >
            <div class="left" @click.stop='toggleChild(index)'>
                <span  class="subTitle" >{{item.name}}</span>
                <img :src="item.isCheck?icon3:icon4" alt="">
            </div>
            <itemlist v-show='item.isCheck' :itemlist="item.children" ></itemlist>
          </div>
      </div>
  </div>
</template>

<script>
import itemlist from "./itemlist"
export default {
  props:["cur","title","childrenList"],
  data () {
    return {
      icon3:require('@/assets/imgs/up1.png'),
      icon4:require('@/assets/imgs/down1.png'),
    }
  },
  components:{
    "itemlist":itemlist,
  },
  methods:{
    toggleChild(index){
      let parentCur=this.cur
      this.$emit('updateToggle',parentCur,index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .subTitle{
      font-size:14px;
      color:#212121;
  }
  .left{
    height:45px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #f3f3f3;
    box-sizing: border-box;
  }
  .left img{
    margin-left:10px;
    width:11.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/homelist.vue